import {
  HttpApiError,
  HttpApiMiddleware,
  HttpApiSecurity,
} from "@effect/platform";
import { CurrentWidget, CurrentWidgetCustomer } from "./widget-context";

/**
 * Public widget middleware: resolves team from the x-widget-id header.
 * No customer authentication required.
 *
 * Endpoints using this middleware get access to `CurrentWidget` (team info).
 * For optional customer auth, handlers can call `resolveWidgetCustomer()`.
 */
export class WidgetPublic extends HttpApiMiddleware.Tag<WidgetPublic>()(
  "WidgetPublic",
  { failure: HttpApiError.Unauthorized, provides: CurrentWidget },
) {}

/**
 * Authenticated widget middleware: resolves team from x-widget-id header
 * AND requires customer authentication via Bearer token.
 *
 * The Bearer token is a customer widget JWT containing teamId and customerEmail.
 * The implementation also reads x-widget-id from the request to validate
 * the team matches the JWT claims.
 */
export class WidgetAuthenticated extends HttpApiMiddleware.Tag<WidgetAuthenticated>()(
  "WidgetAuthenticated",
  {
    failure: HttpApiError.Unauthorized,
    provides: CurrentWidgetCustomer,
    security: { bearer: HttpApiSecurity.bearer },
  },
) {}
